import { IconProps } from 'src/utils/icon';

const TimesIcon: React.FC<IconProps> = ({ size = 1, fill = '#2c2a29' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    viewBox="0 0 14 14"
  >
    <path
      fill="#000"
      d="M9.082 7l4.713-4.629a.678.678 0 000-.97L12.7.326a.708.708 0 00-.988 0L7 4.955 2.287.326a.708.708 0 00-.988 0L.205 1.401a.678.678 0 000 .97L4.917 7 .205 11.629a.678.678 0 000 .97L1.3 13.674a.708.708 0 00.988 0L7 9.045l4.713 4.629a.708.708 0 00.988 0l1.095-1.076a.678.678 0 000-.97L9.082 7z"
    />
  </svg>
);

export default TimesIcon;
